import React, { useState } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import "./LoginPage.css";
// import PropTypes from 'prop-types';
import authApi from '../apis/authApi';

// LoginPage.propTypes = {
    
// };

function LoginPage(props) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [otp, setOtp] = useState("");

    const changeUsernameInputValue = (e) => {
        setUsername(e.target.value);
    }
    const changePasswordInputValue = (e) => {
        setPassword(e.target.value);
    }
    const changeOtpInputValue = (e) => {
        setOtp(e.target.value);
    }

    // Validation Form
    const validationForm = () => {
        let returnData = {
            error: false,
            msg: ""
        }

        // const {username, password} = this.state;

        // Kiểm tra username
        const re = /\S/;
        if(!re.test(username)) {
            returnData = {
                error: true,
                msg: 'Not match username format'
            }
        }

        // // Kiểm tra password dài ít nhất 8 kí tự
        // if(password.length < 8) {
        //     returnData = {
        //         error: true,
        //         msg: "Length of password must be greater than 8 character"
        //     }
        // }

        // Kiểm tra OTP dài 6 ký tự số
        const reOtp = /^[0-9]*$/;
        if(!reOtp.test(otp)) {
            returnData = {
                error: true,
                msg: 'Not match OTP format'
            }
        }

        return returnData;
    }

    const fetchSignIn = async () => {
        try{
            const signInData = {
                username: username,
                password: password,
                code: otp
            };

            const response = await authApi.post(signInData);

            // console.log("Fetch successfully: ", response);

            // console.log("Login success");

            localStorage.setItem("token", response.description);
            //sessionStorage.setItem("token", response.description);

            // navigate('/articles');

            props.onHandleChange(true);

        } catch(error) {
            // console.log("Failed to fetch sign in: ", error);
            alert("Invalid username or password or OTP!");
        }
    }

    const submitForm = (e) => {
        e.preventDefault();

        const validation = validationForm();

        if(validation.error) {
            alert(validation.msg);
        } else {
            alert("Submit form sign in success");
            fetchSignIn();
        }
    }

    return (
        <div  className="d-flex align-items-center justify-content-center">
            <Form className='login-form'
                onSubmit={e => {
                    submitForm(e);
                }}
            >
                <FormGroup>
                    <Label for='username'>
                        Username:
                    </Label>
                    <Input
                        id='username'
                        name='username'
                        placeholder='Type username'
                        type='text'
                        onChange={e => changeUsernameInputValue(e)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for='password'>
                        Password:
                    </Label>
                    <Input
                        id='password'
                        name='password'
                        placeholder='Type your password'
                        type='password'
                        onChange={e => changePasswordInputValue(e)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for='otp'>
                        OTP:
                    </Label>
                    <Input
                        id='otp'
                        name='otp'
                        placeholder='Type OTP'
                        type='text'
                        onChange={e => changeOtpInputValue(e)}
                    />
                </FormGroup>
                <Button
                    color='primary'
                    block={true}
                    outline={true}
                >
                    Submit
                </Button>
            </Form>
        </div>
    );
}

export default LoginPage;